import { CSSProperties } from "react";
import { cn } from "../../lib/utils";

export default function Skeleton({
  width,
  height,
  $variant,
  style,
  className,
}: {
  width?: number | string;
  height?: number | string;
  $variant?:
    "rounded" | "text" | "inline" | "pill" | "rectangular" | "circular";
  style?: CSSProperties;
  className?: string;
}) {
  const computedWidth =
    typeof width === "number" ? `${width}px` : (width ?? "100%");
  const computedHeight =
    typeof height === "number" ? `${height}px` : (height ?? "1em");

  return (
    <div
      className={cn(
        "block bg-[#e0e0e0] rounded-[4px] relative overflow-hidden skeleton-shimmer",
        $variant === "inline" && "inline-block my-0.5",
        $variant === "text" && "my-0.5",
        $variant === "pill" && "inline-block mt-1.5 rounded-[999px]!",
        $variant === "rounded" && "rounded-[8px]!",
        $variant === "rectangular" && "rounded-none!",
        $variant === "circular" && "rounded-full!",
        className
      )}
      style={{ width: computedWidth, height: computedHeight, ...style }}
    />
  );
}
